import type { PhoneIdentity } from '@/types/types';

/**
 * A masked link recipient has no phone on the client: auth-service resolves it
 * from the link and texts the code without revealing the number.
 */
const getPhoneDestination = (phone: PhoneIdentity | null, fallback: string): string => (
    phone?.prefix && phone?.phone
        ? `+${phone.prefix}${phone.phone}`
        : fallback
);

export default getPhoneDestination;
